import React, { useEffect, useState } from 'react';
import { ZODIAC_ORDER, ZODIAC_DATA } from '../constants';

const ZodiacClock: React.FC<{ size?: number }> = ({ size = 60 }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours();

  const secDeg = (seconds / 60) * 360;
  const minDeg = ((minutes + seconds / 60) / 60) * 360;
  const hourDeg = ((hours % 12 + minutes / 60) / 12) * 360;

  // Scale factor based on default design size of roughly 100px viewbox behavior
  const scale = size / 100;

  return (
    <div 
      className="relative flex items-center justify-center bg-transparent"
      style={{ width: size, height: size }}
    >
        {/* Outer Glow Ring */}
        <div className="absolute inset-0 rounded-full border-2 border-purple-500/30 shadow-[0_0_15px_rgba(168,85,247,0.4)] animate-pulse"></div>
        
        {/* Zodiac Ring */}
        <div className="absolute w-full h-full animate-[spin_60s_linear_infinite]">
            {ZODIAC_ORDER.map((sign, i) => {
                const angle = (i * 30) * (Math.PI / 180);
                // Radius for icons
                const r = 40 * scale; 
                const x = 50 * scale + r * Math.sin(angle);
                const y = 50 * scale - r * Math.cos(angle);
                
                return (
                    <div 
                        key={sign}
                        className="absolute flex items-center justify-center text-purple-300 transform -translate-x-1/2 -translate-y-1/2"
                        style={{ 
                            left: x, 
                            top: y, 
                            fontSize: `${10 * scale}px`,
                            textShadow: '0 0 5px rgba(168,85,247,0.8)'
                        }}
                    >
                        <div style={{ transform: `rotate(${-i * 30}deg)` }}>
                           {ZODIAC_DATA[sign].symbol}
                        </div>
                    </div>
                );
            })}
        </div>

        {/* Inner Circle */}
        <div className="absolute rounded-full border border-purple-400/50 bg-[#0B1229]" style={{ width: size * 0.65, height: size * 0.65 }}></div>

        {/* Clock Hands */}
        <div className="absolute inset-0 flex items-center justify-center">
            {/* Hour Hand */}
            <div 
                className="absolute bg-purple-400 rounded-full origin-bottom"
                style={{ 
                    width: 3 * scale, 
                    height: 18 * scale, 
                    bottom: '50%', 
                    transform: `rotate(${hourDeg}deg)`,
                    boxShadow: '0 0 5px rgba(168,85,247,0.8)'
                }}
            ></div>
            {/* Minute Hand */}
            <div 
                className="absolute bg-purple-300 rounded-full origin-bottom"
                style={{ 
                    width: 2 * scale, 
                    height: 26 * scale, 
                    bottom: '50%', 
                    transform: `rotate(${minDeg}deg)` 
                }}
            ></div>
            {/* Second Hand */}
            <div 
                className="absolute bg-primary rounded-full origin-bottom"
                style={{ 
                    width: 1 * scale, 
                    height: 28 * scale, 
                    bottom: '50%', 
                    transform: `rotate(${secDeg}deg)` 
                }}
            ></div>
            {/* Center Dot */}
            <div className="absolute bg-white rounded-full z-10" style={{ width: 4 * scale, height: 4 * scale }}></div>
        </div>
    </div>
  );
};

export default ZodiacClock;